import type React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Exercises } from '@pages/programs/exercise-list/ui.tsx';
import { ProgramHistoryPage } from '@pages/programs/history/index.ts';
import { ProgramComments } from '@pages/programs/ProgramComments/index.tsx';
import { ProgramPublicationPage } from '@pages/programs/publication-page/ui.tsx';
import { RecommendedProgramPage } from '@pages/programs/recommended-program-page/index.tsx';
import { RecommendedProgramComments } from '@pages/programs/RecommendedProgramComments/index.tsx';
import { CommentEdit } from '@widgets/shared/Comments/CommentEdit/index.tsx';
import { ModalBuy, ModalRecommend, ModalShare } from '@features/programs';
import { ProgramEditor } from './editor';
import { Exercise } from './exercise';
import { ExerciseEdit } from './exercise-edit';
import { ProgramDescVideo } from './program-description-exersice';
import { ProgramList } from './program-list';
import { ProgramPage } from './program-page';
import { Promo } from './promo';
import { PromoEdit } from './promo-edit';
import { Subscribe } from './subscribe';

export const Programs: React.FC = () => {
  const location = useLocation();
  const background = location.state && location.state.background;

  return (
    <>
      <Routes location={background || location}>
        <Route path=":code">
          <Route index element={<ProgramList />} />

          <Route path="history" element={<ProgramHistoryPage />} />

          <Route path="program-edit">
            <Route path=":id">
              <Route index element={<ProgramEditor />} />

              <Route path="exercise">
                <Route path="new" element={<ExerciseEdit isTempExercise />} />
                <Route path=":videoId">
                  <Route index element={<Exercise isTempExercise />} />
                  <Route path="edit" element={<ExerciseEdit isTempExercise />} />
                </Route>
              </Route>

              <Route path="promo/:videoId" element={<Promo />} />
              <Route path="promo-edit/:videoId" element={<PromoEdit />} />
            </Route>
          </Route>

          <Route path="subscribe/:id/:hash" element={<Subscribe />} />

          <Route path="program">
            <Route path=":id">
              <Route index element={<ProgramPage />} />
              <Route path="publication" element={<ProgramPublicationPage />} />

              {/* комментарии */}
              <Route path="comments">
                <Route index element={<ProgramComments />} />
                <Route path=":commentId" element={<CommentEdit />} />
              </Route>
            </Route>

            <Route path="recommended/:hash">
              <Route index element={<RecommendedProgramPage />} />
              {/* комментарии рекомендованной программы */}
              <Route path="comments">
                <Route index element={<RecommendedProgramComments />} />
                <Route path=":commentId" element={<CommentEdit />} />
              </Route>
            </Route>

            <Route path="description" element={<ProgramDescVideo />} />
          </Route>

          <Route path="exercise/:videoId" element={<Exercise />} />
          <Route path="exercise-edit/:videoId" element={<ExerciseEdit />} />

          <Route path="exercises">
            <Route index element={<Exercises />} />
          </Route>
        </Route>
      </Routes>
      <ModalBuy />
      <ModalRecommend />
      <ModalShare />
    </>
  );
};
